import { css } from '@emotion/react';

export const themeAnnotationsStyles = css`
    // section styles
    font-size: var(--sectionComponent-fontSize);
    font-weight: var(--sectionComponent-fontWeight);
    font-family: var(--sectionComponent-fontFamily);
    word-spacing: var(--sectionComponent-wordSpacing);
    line-height: var(--sectionComponent-lineHeight);
    text-indent: var(--sectionComponent-textIndent);
    text-align: var(--sectionComponent-horizontalAlignment);
    vertical-align: var(--sectionComponent-verticalAlignment);
    padding: var(--sectionComponent-padding);
    margin: var(--sectionComponent-margin);
    color: var(--sectionComponent-color);

    sup {
        a {
            font-size: var(--linkComponent-fontSize);
            font-weight: var(--linkComponent-fontWeight);
            font-family: var(--linkComponent-fontFamily);
            line-height: var(--linkComponent-lineHeight);
            color: var(--linkComponent-textColor);
            text-decoration: var(--linkComponent-textDecoration);

            &:hover {
                color: var(--linkComponent-hoverTextColor);
            }

            &:visited {
                color: var(--linkComponent-visitedTextColor);
            }

            &:active {
                color: var(--linkComponent-activeTextColor);
            }
        }
    }
`;
